import { GlobalToken, Modal } from 'antd';
import styled from 'styled-components';

export const StyledModal = styled(Modal)<{ theme: { token: GlobalToken } }>`
  .ant-modal-content {
    background: ${({ theme: { token } }) => token.colorBgContainer};
    border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
    padding: 0;
    box-shadow: ${({ theme: { token } }) => token.boxShadow};
  }

  .ant-modal-close {
    width: ${({ theme: { token } }) => token.controlHeight}px;
    height: ${({ theme: { token } }) => token.controlHeight}px;
    right: ${({ theme: { token } }) => token.padding}px;
    top: ${({ theme: { token } }) => token.paddingLG}px;
    color: ${({ theme: { token } }) => token.colorTextLightSolid};

    &:hover {
      background: ${({ theme: { token } }) => token.colorBgTextHover};
      border-radius: ${({ theme: { token } }) => token.borderRadius}px;
    }
  }

  .modal-header {
    padding: ${({ theme: { token } }) => `${token.paddingLG}px ${token.padding}px ${token.paddingXS}px`};
    display: flex;
    align-items: center;
  }

  .modal-header-text {
    color: ${({ theme: { token } }) => token.colorTextHeading};
    font-family: ${({ theme: { token } }) => token.fontFamily};
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    line-height: ${({ theme: { token } }) => token.lineHeightLG};
  }

  .modal-content {
    padding: ${({ theme: { token } }) => `0 ${token.padding}px ${token.paddingXS}px`};
    display: flex;
    flex-direction: column;
    gap: ${({ theme: { token } }) => token.padding}px;
  }

  .context-text {
    color: ${({ theme: { token } }) => token.colorText};
    font-family: ${({ theme: { token } }) => token.fontFamily};
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    font-weight: ${({ theme: { token } }) => token.fontWeight};
    line-height: ${({ theme: { token } }) => token.lineHeight};
  }
`;

export const CommentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { token } }) => token.paddingXS}px;

  .label-container {
    display: flex;
    align-items: center;
    gap: ${({ theme: { token } }) => token.paddingXXS}px;

    .required-mark {
      color: ${({ theme: { token } }) => token.colorError};
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    }

    .label {
      color: ${({ theme: { token } }) => token.colorText};
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      font-family: ${({ theme: { token } }) => token.fontFamily};
    }
  }

  .comment-input {
    height: ${({ theme: { token } }) => token.controlHeight}px;
    padding: 0 ${({ theme: { token } }) => token.paddingXS}px;
    background: ${({ theme: { token } }) => token.colorBgContainer};
    border: ${({ theme: { token } }) => token.lineWidth}px solid ${({ theme: { token } }) => token.colorBorder};
    border-radius: ${({ theme: { token } }) => token.borderRadius}px;
    color: ${({ theme: { token } }) => token.colorText};
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    font-family: ${({ theme: { token } }) => token.fontFamily};
    width: 100%;

    &::placeholder {
      color: ${({ theme: { token } }) => token.colorTextPlaceholder};
    }

    &:focus {
      outline: none;
      border-color: ${({ theme: { token } }) => token.colorPrimary};
    }

    &:disabled {
      background: ${({ theme: { token } }) => token.colorBgContainerDisabled};
      cursor: not-allowed;
      color: ${({ theme: { token } }) => token.colorTextDisabled};
    }
  }
`;

export const ModalActions = styled.div`
  padding: ${({ theme: { token } }) => `0 ${token.padding}px ${token.paddingLG}px`};
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme: { token } }) => token.paddingXS}px;

  .cancel-button {
    border-color: ${({ theme: { token } }) => token.colorBorder};
  }
`;
